import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { AutomationInboxMenu } from "@/components/shell/automation-inbox-menu";
import { useTenantContext } from "@/lib/hooks/use-tenant-context";
import { resolveWorkspaceDisplayName } from "@/lib/tenant-display";

export function Header() {
  const { tenantId, tenant: tenantRecord } = useTenantContext();
  const workspaceName = tenantId
    ? resolveWorkspaceDisplayName(
      tenantId,
      [tenantRecord?.name, tenantRecord?.authTenantName, tenantRecord?.slug, tenantRecord?.authTenantSlug],
      "Tenant",
    )
    : null;

  return (
    <header className="flex items-center h-12 px-4 border-b border-sidebar-border shrink-0 gap-2">
      <SidebarTrigger className="-ml-1" />
      <Separator orientation="vertical" className="mr-2 data-[orientation=vertical]:h-4" />
      <div className="flex min-w-0 flex-1 items-center justify-between gap-3">
        <span className="truncate text-sm font-semibold tracking-tight" style={{ color: "var(--text-strong)" }}>
          Agentiq.team{workspaceName ? ` \u2014 ${workspaceName}` : ""}
        </span>
        <AutomationInboxMenu />
      </div>
    </header>
  );
}
